import PropTypes from 'prop-types';
import React from 'react';
// import ReactDOM from 'react-dom';

class CalendarCustomInput extends React.Component {
  focus() {
    this[this.props.id].focus();
  }

  render() {
    const { onClick, id } = this.props;
    return (
      <div>
        <input type="text"
          {...this.props}
          ref={(input) => { this[id] = input; }}
        />
        {
          /* eslint jsx-a11y/no-static-element-interactions:0 */
          this.props.value &&
            <a
              onClick={onClick}
              aria-label={this.props['aria-label']}
              style={{ textDecoration: 'none' }}
            >
            </a>
        }
      </div>
    );
  }
}

CalendarCustomInput.propTypes = {
  onClick: PropTypes.func,
  'aria-label': PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
};

export default CalendarCustomInput;